/**
 * Gets user's approximate location based on their IP address
 * Uses ipapi.co which provides free IP geolocation
 */
export const getUserLocationFromIP = async () => {
    try {
        const response = await fetch('https://ipapi.co/json/');
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        // Validate that we got valid coordinates
        if (typeof data.latitude !== 'number' || typeof data.longitude !== 'number') {
            throw new Error('Invalid coordinates received from geolocation service');
        }
        return {
            lat: data.latitude,
            lng: data.longitude,
            country: data.country_name,
            city: data.city,
            region: data.region
        };
    }
    catch (error) {
        console.warn('Failed to get user location from IP:', error);
        // Fallback to Rocky Mountain National Park coordinates
        return {
            lat: 40.3428,
            lng: -105.6836
        };
    }
};
/**
 * Gets user's location with browser geolocation API as fallback
 * This requires user permission but is more accurate
 */
export const getUserLocationWithBrowserAPI = () => {
    return new Promise((resolve) => {
        if (!navigator.geolocation) {
            // Browser doesn't support geolocation, fall back to IP
            getUserLocationFromIP().then(resolve);
            return;
        }
        navigator.geolocation.getCurrentPosition((position) => {
            resolve({
                lat: position.coords.latitude,
                lng: position.coords.longitude
            });
        }, () => {
            // User denied permission or other error, fall back to IP
            getUserLocationFromIP().then(resolve);
        }, {
            timeout: 5000,
            enableHighAccuracy: false
        });
    });
};
